import React from 'react'
import InputFieldUI from './InputFieldUI'

const InputReadOnlyUI = ({context, name, value, label, messageList, labelKey, required}) =>
  <InputFieldUI className='w_input_ro' name={name} required={required} label={label} messageList={messageList} labelKey={labelKey}>
    <div className='g_m_left_50'>
      {value}
    </div>
  </InputFieldUI>

export default InputReadOnlyUI
